export default __webpack_public_path__ + "static/media/s3-006.4d364180.jpg";